import React, { useMemo, useState } from 'react';
import DebounceTextInput from 'components/DebounseTextInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { Col, Row } from 'reactstrap';
import AdvancedFilters from 'components/AdvancedFilters';
import OffersFilter from '../../../OffersFilter';
import ForwardOffersTable from './components/ForwardOffersTable';
import DateSearchFilter from '../DateSearchFilter';

const initialValues = {
  trader: null,
  grade: null,
  cityName: '',
  status: null,
  // state: null,
};
const ForwardOffers = ({ handleViewDetail, productFilter = [], selectedProductName }) => {
  const [searchString, setSearchString] = useState('');
  const [filterValue, setFilterValue] = useState([]);
  const [showAdvancedSearchBar, setShowAdvancedSearchBar] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const toggleAdvancedSearchBar = () => {
    setShowAdvancedSearchBar(!showAdvancedSearchBar);
  };
  const handleResetFilter = () => {
    setFilterValue([]);
    setDateRange({ startDate: null, endDate: null });
    setShowAdvancedSearchBar(false);
  };
  const handleChange = (value) => {
    setSearchString(value);
  };
  const statusFilter = {
    key: 'kycStatus',
    value: 'ALL',
    type: 'STRING',
    op: 'EQ',
  };
  const handleFilters = (val) => {
    const traderFilter = val?.trader
      ? val.trader.id && !Number.isNaN(Number(val.trader.id))
        ? [
            {
              key: 'id',
              value: String(val.trader.id),
              joinAttributeName: 'trader',
              type: 'INT',
              op: 'EQ',
            },
          ]
        : [
            {
              key: 'firstName',
              value:
                val.trader.firstName ||
                (typeof val.trader === 'string' ? val.trader : val.trader.id) ||
                '',
              joinAttributeName: 'trader',
              type: 'STRING',
              op: 'LIKE',
            },
          ]
      : [];

    setFilterValue([
      {
        key: 'cityName',
        value: val?.cityName ? val?.cityName : '',
        joinAttributeName: 'city',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'name',
        value: val?.grade?.name ? val?.grade?.name : '',
        setAttribute: 'grades',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      ...traderFilter,
      {
        key: 'status',
        value: val?.status?.id || 'All',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
    ]);
  };

  const createdDateRangeFilter = useMemo(() => {
    if (!dateRange?.startDate || !dateRange?.endDate) return [];

    const startDate = new Date(dateRange.startDate);
    const endDate = new Date(dateRange.endDate);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    return [
      {
        key: 'createdAt',
        value: startDate.valueOf(),
        type: 'DATE',
        op: 'GTE',
      },
      {
        key: 'createdAt',
        value: endDate.valueOf(),
        type: 'DATE',
        op: 'LTE',
      },
    ];
  }, [dateRange]);

  const handleDateRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setDateRange({ startDate, endDate });
  };

  return (
    <ErrorBoundary>
      <Row>
        <Col sm={6}>
          <AdvancedFilters
            handleFilters={handleFilters}
            initialValues={initialValues}
            id="market_list_offer"
            PositionLeft="382px"
            PositionTop="-32px"
            toggleAdvancedSearchBar={toggleAdvancedSearchBar}
          >
            <OffersFilter statusFilter={statusFilter} />
          </AdvancedFilters>
          <DateSearchFilter
            dateRange={dateRange}
            onChange={handleDateRangeChange}
            className="position-absolute"
            style={{ left: '500px', marginTop: '-32px' }}
          />
        </Col>

        <Col className="text-end" sm={6}>
          <DebounceTextInput
            onInputChange={handleChange}
            delay={500} // Set your desired delay in milliseconds
            value={searchString}
            placeholder="Search by seller"
            positionTop="-34px"
          />
        </Col>
      </Row>
      <ForwardOffersTable
        searchString={searchString}
        handleViewDetail={handleViewDetail}
        filterValue={[
          ...filterValue,
          ...createdDateRangeFilter,
        ]}
        handleResetFilter={handleResetFilter}
        showAdvancedSearchBar={
          showAdvancedSearchBar ||
          Boolean(dateRange?.startDate && dateRange?.endDate)
        }
        selectedProductName={selectedProductName}
      />
    </ErrorBoundary>
  );
};

export default ForwardOffers;
